import React from "react";
import styled from "styled-components";


export function AppProjectBox({ img, title, text, androidUrl, iosUrl }) {
  return (
    <Wrapper>
      <ImgBtn className="animate pointer">
        <img className="radius8" src={img} alt="project"></img>
      </ImgBtn>
       <h3 className="font20 extraBold">{title}</h3>
      <p className="font13">{text}</p>
      <AppButtons>
        {/* Show Android button only if androidUrl exists */}
        {androidUrl && (
          <PlatformButton onClick={() => window.open(androidUrl, '_blank')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.3-.15-.68-.04-.84.26l-1.88 3.24c-2.86-1.21-6.08-1.21-8.94 0L5.65 5.71c-.16-.3-.54-.41-.84-.26-.3.16-.41.54-.26.85L6.4 9.48C3.3 11.25 1.28 14.44 1 18h22c-.28-3.56-2.3-6.75-5.4-8.52zM7 15.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25zm10 0c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25-.56 1.25-1.25 1.25z"/>
            </svg>
          </PlatformButton>
        )}
        
        {/* Show iOS button only if iosUrl exists */}
        {iosUrl && (
          <PlatformButton onClick={() => window.open(iosUrl, '_blank')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.05 12.04C17.02 9.28 19.36 8.03 19.47 7.97C18.27 6.19 16.38 5.94 15.72 5.93C14.08 5.77 12.53 6.97 11.73 6.97C10.91 6.97 9.63 5.95 8.27 5.99C6.45 6.04 4.79 7.03 3.83 8.64C1.77 11.85 3.07 16.89 4.87 19.57C5.79 20.9 6.86 22.38 8.21 22.33C9.52 22.28 10.01 21.5 11.67 21.5C13.32 21.5 13.78 22.33 15.14 22.29C16.54 22.25 17.48 20.9 18.38 19.56C19.47 18 19.97 16.48 20 16.41C19.97 16.38 17.07 15.35 17.05 12.04ZM14.7 4.18C15.34 3.41 15.81 2.35 15.65 1.25C14.69 1.29 13.53 1.89 12.86 2.66C12.27 3.34 11.69 4.42 11.86 5.48C12.92 5.55 14.03 4.98 14.7 4.18Z"/>
            </svg>
          </PlatformButton>
        )}
      </AppButtons>
      
     
    </Wrapper>
  );
}

export  function ProjectBox({ img, title, text, action }) {
  return (
    <Wrapper >
      <ImgBtn className="aniamte pointer" onClick={action ? () => action() : null}>
        <img className="radius8" src={img} alt="project"></img>
      </ImgBtn>
      <h3 className="font20 extraBold">{title}</h3>
      <p className="font13">{text}</p>
    </Wrapper>
  );
}



const Wrapperold = styled.div`
  width: 100%;
  margin-top: 30px;
  position: relative;
  img {
    width: 100%;
    height: auto;
    margin: 20px 0;
  }
  h3 {
    padding-bottom: 15px;
  }
`;
const Wrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  position: relative;
  img {
    width: 100%;
    height: 200px; /* Fixed height */
    object-fit: contain; /* This will crop and maintain aspect ratio */
    margin: 20px 0;
    border-radius: 8px;
  }
  h3 {
    padding-bottom: 15px;
  }
`;

const ImgBtn = styled.button`
  background-color: transparent;
  border: 0px;
  outline: none;
  padding: 0px;
  margin: 0px;
  position: relative;
  :hover > img {
    opacity: 0.5;
  }
`;

const UrlOverlay = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-align: center;
  backdrop-filter: blur(5px);
`;
const AppButtons = styled.div`
  display: flex;
  gap: 8px;
  margin: 6px 0;
  justify-content: center;
`;

const PlatformButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #6c757d;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    background: #007bff;
    color: white;
    border-color: #007bff;
    transform: translateY(-1px);
  }
`;